export const COLLECTION_LIST_REQUEST = "COLLECTION_LIST_REQUEST";
export const COLLECTION_LIST_SUCCESS = "COLLECTION_LIST_SUCCESS";
export const COLLECTION_LIST_FAIL = "COLLECTION_LIST_FAIL";

export const COLLECTION_DETAIL_REQUEST = "COLLECTION_DETAIL_REQUEST";
export const COLLECTION_DETAIL_SUCCESS = "COLLECTION_DETAIL_SUCCESS";
export const COLLECTION_DETAIL_FAIL = "COLLECTION_DETAIL_FAIL";
